export default __webpack_public_path__ + "static/media/avatar_koala6.b3ba5d93.mp3";